// 9fbef606107a605d69c0edbcd8029e5d
import { ORDERS_ACTION_PATTERN } from '../../../../constants/reducer.constants';

export default {
  GET_ORDERS_LIST: `${ORDERS_ACTION_PATTERN}GET_ORDERS_LIST`,
  GET_DELIVERED_ORDERS_LIST: `${ORDERS_ACTION_PATTERN}GET_DELIVERED_ORDERS_LIST`,
  SET_ORDERS_LIST: `${ORDERS_ACTION_PATTERN}SET_ORDERS_LIST`,
  SET_ORDERS_LIST_STORE: `${ORDERS_ACTION_PATTERN}SET_ORDERS_LIST_STORE`,
  SET_DELIVER_ORDERS_IDs: `${ORDERS_ACTION_PATTERN}SET_DELIVER_ORDERS_IDs`,
  SET_CHANGED_SITEID: `${ORDERS_ACTION_PATTERN}SET_CHANGED_SITEID`,
  SHOW_LOADER: `${ORDERS_ACTION_PATTERN}SHOW_LOADER`,
  HIDE_LOADER: `${ORDERS_ACTION_PATTERN}HIDE_LOADER`,
  SHOW_CTL_LOADER: `${ORDERS_ACTION_PATTERN}SHOW_CTL_LOADER`,
  HIDE_CTL_LOADER: `${ORDERS_ACTION_PATTERN}HIDE_CTL_LOADER`,
  HIDE_LOAD_MORE: `${ORDERS_ACTION_PATTERN}HIDE_LOAD_MORE`,
  SHOW_LOAD_MORE: `${ORDERS_ACTION_PATTERN}SHOW_LOAD_MORE`,
  GET_ACCOUNT_DRAWER_ORDERS_LIST: `${ORDERS_ACTION_PATTERN}GET_ACCOUNT_DRAWER_ORDERS_LIST`,
  SET_ACCOUNT_DRAWER_ORDERS_LIST: `${ORDERS_ACTION_PATTERN}SET_ACCOUNT_DRAWER_ORDERS_LIST`,
  CLEAR_ACCOUNT_DRAWER_ORDERS_LIST: `${ORDERS_ACTION_PATTERN}CLEAR_ACCOUNT_DRAWER_ORDERS_LIST`,
  SHOW_ACCOUNT_DRAWER_ORDERS_LOADER: `${ORDERS_ACTION_PATTERN}SHOW_ACCOUNT_DRAWER_ORDERS_LOADER`,
  HIDE_ACCOUNT_DRAWER_ORDERS_LOADER: `${ORDERS_ACTION_PATTERN}HIDE_ACCOUNT_DRAWER_ORDERS_LOADER`,
  LOGGER_ERROR_MESSAGE: 'getOrderHistory error',
  ORDER_SIZE: 5,
  OPTIMIZED_ORDER_SIZE: 2,
  OPTIMIZED_ACCOUNT_DRAWER_ORDER_SIZE: 3,
  DEFAULT_ACCOUNT_DRAWER_ORDERS_CACHE_TTL: 15 * 60 * 1000,
  SET_RECENT_ORDERDETAILS: `${ORDERS_ACTION_PATTERN}SET_RECENT_ORDERDETAILS`,
  SET_NEW_LOADER: `${ORDERS_ACTION_PATTERN}SET_NEW_LOADER`,
  SET_SELECTED_ORDERS_YEAR: `${ORDERS_ACTION_PATTERN}SET_SELECTED_ORDERS_YEAR`,
  SET_PAGINATION: `${ORDERS_ACTION_PATTERN}SET_PAGINATION`,
  TOGGLE_FILTER_MODAL: `${ORDERS_ACTION_PATTERN}TOGGLE_FILTER_MODAL`,
  SET_COMPANY_ID: `${ORDERS_ACTION_PATTERN}SET_COMPANY_ID`,
  SET_FILTER_OPTIONS: `${ORDERS_ACTION_PATTERN}SET_FILTER_OPTIONS`,
  SET_ORDER_ERROR: `${ORDERS_ACTION_PATTERN}SET_ORDER_ERROR`,

  STATUS_CONSTANTS: {
    ORDER_SHIPPED: 'order shipped',
    ORDER_PARTIALLY_SHIPPED: 'partially shipped',
    ITEMS_READY_FOR_PICKUP: 'ready for pickup',
    ITEM_READY_FOR_PICK_UP: 'ready for pick up',
    ITEMS_PICKED_UP: 'picked up',
    ORDER_PICKED_UP: 'order picked up',
    EXPIRED: 'order expired',
    CANCELLED: 'order cancelled',
    SUCCESSFULLY_PICKED_UP: 'successfully picked up',
    ORDER_RECEIVED: 'order received',
    ORDER_IN_PROCESS: 'order in process',
    ORDER_CANCELED: 'canceled',
    ORDER_CANCELLED: 'cancelled',
    ITEMS_RECEIVED: 'received',
    ORDER_RECEIVED_LABEL: 'lbl_orders_statusOrderReceived',
    ORDER_PREPARING: 'preparing order',
    PROCESSING: 'processing',
    ORDER_BEING_PROCESSED: 'order being processed',
    PREPARING_YOUR_ORDER: 'preparing your order',
    PICKUP_EXPIRED: 'pickup expired',
    PICKUP_ITEM_EXPIRED: 'expired',
    SHIPPED: 'shipped',
    DELIVERED: 'delivered',
    CALL_NEEDED: 'call needed',
    IN_TRANSIT: 'in transit',
    OUT_FOR_DELIVERY: 'out for delivery',
    PARTIALLY_CANCELED: 'partially canceled',
    PARTIALLY_CANCELLED: 'partially cancelled',
    RETURNS: 'returns',
    RETURNS_COMPLETED: 'return(s) completed',
    RETURNS_INITIATED: 'return(s) initiated',
    NA: 'n/a',
    PARTIALLY_SHIPPED: 'order partially shipped',
    IN_PROCESS: 'in process',
    RETURN_INITIATED: 'return initiated',
    RETURN_COMPLETED: 'return completed',
    REFUNDED: 'refunded',
    ORDER_PROCESSING: 'order processing',
    CANCELED: 'canceled',
    COMPLETED: 'completed',
  },
};
